// extracted by mini-css-extract-plugin
export default {"background":"Login_background__e9mKx","logo":"Login_logo__3-3nU","btnStyle":"Login_btnStyle__9yDSF"};